import { render } from "./OrgChart2.vue?vue&type=template&id=84f5cf24&scoped=true"
import script from "./OrgChart2.vue?vue&type=script&lang=js"
export * from "./OrgChart2.vue?vue&type=script&lang=js"

import "./OrgChart2.vue?vue&type=style&index=0&id=84f5cf24&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f5cf24"]])

export default __exports__